module.exports = __webpack_public_path__ + "static/img/8.38ea902.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/8.png
// module id = d6oc
// module chunks = 0